import { IInitiativeSelection } from "../pages";

export const findInitiative = (selectedInitiatives: IInitiativeSelection[], playerSelectedInitiative: string) => {
  const initiativeNames = new Set(selectedInitiatives.map(initiative => initiative.initiativeName));
  return initiativeNames.has(playerSelectedInitiative);
};
